import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';

export type PayflowHostedMessage = {
  type: 'payflow-hosted';
  sessionId: string;
  status: 'approved' | 'declined' | 'canceled' | 'error' | string;
  result?: string;
};

type PayflowHostedCardFrameProps = {
  iframeUrl: string;
  sessionId: string;
  height?: number;
  onMessage: (msg: PayflowHostedMessage) => void;
};

/**
 * Embeds Payflow Layout C hosted checkout and listens for return-page postMessage.
 */
const PayflowHostedCardFrame: React.FC<PayflowHostedCardFrameProps> = ({
  iframeUrl,
  sessionId,
  height = 565,
  onMessage,
}) => {
  useEffect(() => {
    const handler = (event: MessageEvent) => {
      const data = event.data as PayflowHostedMessage | null;
      if (!data || typeof data !== 'object') return;
      if (data.type !== 'payflow-hosted') return;
      if (data.sessionId && data.sessionId !== sessionId) return;
      onMessage(data);
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [sessionId, onMessage]);

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Enter the card details in the secure PayPal form below. Card numbers are
        not sent to Hub.
      </Typography>
      <Box
        component="iframe"
        title="PayPal hosted card entry"
        src={iframeUrl}
        sx={{
          width: '100%',
          height,
          border: 1,
          borderColor: 'divider',
          borderRadius: 1,
        }}
        sandbox="allow-top-navigation allow-scripts allow-same-origin allow-forms allow-modals"
      />
    </Box>
  );
};

export default PayflowHostedCardFrame;
